import axios from 'axios'//
const maiyuanRequest = axios.create({
     baseURL:"https://guess-admin.maiyuan.online/api/",
      // baseURL:"http://192.168.4.40:7888/api/" //本地测试

},)
 
export default maiyuanRequest